
import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CreditCard, FileText, Building2, ChevronLeft, ChevronRight, Menu } from 'lucide-react';

const Sidebar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isCollapsed, setIsCollapsed] = useState(false);

  const navItems = [
    { name: '入金消込', path: '/', icon: CreditCard },
    { name: '組合明細', path: '/union', icon: FileText },
    { name: '得意先管理', path: '/clients', icon: Building2 },
  ];

  return (
    <aside 
      className={`bg-[#2c3e50] text-white flex-shrink-0 hidden md:flex flex-col transition-all duration-300 ease-in-out ${
        isCollapsed ? 'w-16' : 'w-64'
      } border-r border-[#34495e]`}
    >
      <div className="h-16 flex items-center justify-between px-4 bg-[#243342] shadow-md">
        {!isCollapsed && (
          <span className="font-black text-base tracking-tight truncate ml-2">ガイアテック</span>
        )}
        <button 
          onClick={() => setIsCollapsed(!isCollapsed)}
          className="p-1.5 hover:bg-[#34495e] rounded transition-colors text-gray-300 ml-auto"
          title={isCollapsed ? "メニューを展開" : "メニューを閉じる"}
        >
          {isCollapsed ? <Menu size={18} /> : <ChevronLeft size={18} />}
        </button>
      </div>

      <nav className="flex-1 py-4">
        {navItems.map((item) => {
          const isActive = item.path === '/' 
            ? location.pathname === '/' 
            : location.pathname.startsWith(item.path);

          return (
            <div
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`flex items-center h-12 mb-1 transition-all relative group cursor-pointer ${
                isActive
                  ? 'bg-[#3498db] text-white'
                  : 'text-gray-300 hover:bg-[#34495e] hover:text-white'
              } ${isCollapsed ? 'justify-center px-0' : 'px-6'}`}
            >
              <item.icon className={`flex-shrink-0 ${isActive ? 'scale-110' : ''}`} size={18} />
              {!isCollapsed && (
                <span className="ml-4 font-bold text-sm whitespace-nowrap">{item.name}</span>
              )}
              {isActive && !isCollapsed && (
                <div className="absolute left-0 top-0 bottom-0 w-1 bg-white"></div>
              )}
              {isCollapsed && (
                <div className="absolute left-full ml-2 px-2 py-1 bg-gray-800 text-white text-[10px] rounded opacity-0 group-hover:opacity-100 pointer-events-none whitespace-nowrap z-50">
                  {item.name}
                </div>
              )}
            </div>
          );
        })}
      </nav>

      <div className={`p-4 bg-[#243342] text-center border-t border-[#34495e] ${isCollapsed ? 'px-0' : ''}`}>
         {!isCollapsed ? (
           <span className="text-[10px] text-gray-500 font-bold">System v5.5</span>
         ) : (
           <span className="text-[8px] text-gray-500 font-black">v5.5</span>
         )}
      </div>
    </aside>
  );
};

export default Sidebar;
